define('presentation/signup/presentationObjects/signupPlansPresentationObject',[],function() {
    return function(){
        let self = this;

        self.affiliateId = null;
        self.planId = null;
        self.telephonyPackageId = null;
        self.liveReceptionistPackageId = null;
        self.webChatPackageId = null;
        self.outboundCallingPackageId = null;
    };
});
